import React from 'react';
// import ReactDOM from 'react-dom';
import {
  select as d3Select,
  // max as d3Max,
  scaleLinear as d3ScaleLinear,
  scaleBand as d3ScaleBand,
  scaleOrdinal as d3ScaleOrdinal,
  axisBottom as d3AxisBottom,
  axisLeft as d3AxisLeft,
  sum as d3Sum,
  mouse as d3Mouse
} from 'd3';

const Medians = [1590.965,1626.261,1628.163,1598.262,1602.617,1621.571,1615.585,1656.389,1712.496,1717.272,1687.793,1721.426,1708.455,1697.704,1685.144,1688.315,1717.660,1697.924,1759.900,1757.533,1734.945,1737.413,1725.821,1757.722];
// import ChartHeader from './ChartHeader';
let currentMedian;

import './barchart.styl';

class Barchart extends React.Component {

  constructor(props) {
    super();

    this.bars = null;
    this.y = null;
    this.x = null;
    this.height = null;
    this.width = window.innerWidth;

    this.year = props.year;
    this.color = d3ScaleOrdinal()
      .range(['#8aadd7','#f39a93'])
      .domain(['subValue', 'value']);

    this.highlightColor = d3ScaleOrdinal()
      .range(['#006ab2', '#e4003a'])
      .domain(['subValue', 'value']);

    currentMedian = Medians[props.year - 1991];

    this.data = this.parseData(props.allData, props.subData);

    this.updateDisplays = this.updateDisplays.bind(this);

    const lastWidth = window.innerWidth;
    d3Select(window).on('resize', () => {
      if(lastWidth !== window.innerWidth) {
        this.createChart();
      }
    });
  }

  componentDidMount() {
    this.createChart();
  }

  createChart() {
    const root = this.refs.barchart;
    const margin = { top: 30, right: 0, bottom: 50, left: 50 };
    const { data, color, highlightColor } = this;
    this.width = d3Select('.ifdw-chart').node().getBoundingClientRect().width - margin.left - margin.right;

    const height = window.innerWidth >= 620 && window.innerWidth < 650 ? 370 : Math.max(250, this.width * .7 - margin.top - margin.bottom);

    const svg = d3Select(root)
      .html('')
      .append('svg')
      .attr('width', this.width + margin.left + margin.right)
      .attr('height', height + margin.top + margin.bottom)
      .append('g')
      .attr('transform', `translate(${margin.left},${margin.top})`);

    const x = d3ScaleBand()
      .domain(data.map(d => d.key))
      .rangeRound([0, this.width])
      // .rangeRoundBands([0, this.width], .1)
      .paddingInner(.1)
      .align(0)


    const y = d3ScaleLinear()
      .domain([0, .12])
      .rangeRound([height, 0]);

    // svg
    //   .append('rect')
    //   .attr('x', x(6))
    //   .attr('y', 0)
    //   .attr('width', x(15) - x(6))
    //   .attr('height', height)
    //   .style('fill', '#eee');

    // svg.append('text')
    //   .attr('x', x(6) + 10)
    //   .attr('y', 20)
    //   .text('XX Prozent der Bevölkerung gehören zur Mittelschicht')
    //   .attr('fill', highlightColor('value'))


    const keys = svg.selectAll('.key')
      .data(data)
      .enter().append('g')
      .classed('key', true)
      .attr('transform', d => `translate(${x(d.key)},0)`)

    // const tooltip = svg.append('g')
    //   .attr('class', 'tooltip')
    //   .style('display', 'none');

    const self = this;

    const bars = keys.selectAll('bar')
      .data((d, i) => {
        d.values = d.values.map(v => {
          v.index = i;
          return v;
        });
        return d.values;
      })
      .enter()
      .append('rect')
      .classed('bar', true)
      .attr('y', d => y(d.v1))
      .attr('width', x.bandwidth())
      .attr('height', d =>  y(d.v0) - y(d.v1))
      .style('fill', (d, i) => {
        if(d.index >= 8 && d.index <= 14) {
          return highlightColor(d.name);
        }
        return color(d.name);
      })
      .on('mouseenter', function(d) {
        let minIncome = currentMedian * d.index / 10;
        let maxIncome = currentMedian * ( d.index + 1 ) / 10;

        if(d.index === 30) {
          maxIncome = currentMedian * 35 / 10;
        }

        if(d.index === 31) {
          minIncome = currentMedian * 35 / 10;
        }

        const ttData = {
          minIncome,
          maxIncome,
          ...d
        }

        self.props.updateState({
          ttData,
          ttVisible: true,
        });

        d3Select(this).classed('hover', true);
      })
      .on('mousemove', d => {
        self.props.updateState({
          ttPosition: d3Mouse(root)
        });
      })
      .on('mouseleave', function(d) {
        self.props.updateState({
          ttVisible: false
        });

        d3Select(this).classed('hover', false);
      });

    const xAxisTickValues = this.width > 500 ? [0, 5, 8, 10, 15, 20, 25, 30] : [0, 5, 10, 15, 20, 25, 30];

    const xAxis = d3AxisBottom(x)
      .tickValues(xAxisTickValues)
      .tickFormat(d => d === 10 ? 'Median' :  d * 10);

    const yAxis = d3AxisLeft(y)
      .tickValues([0,.02,.04,.06,.08,.10,.12])
      .tickFormat(d => d * 100);

    svg.append('g')
      .classed('axis x-axis', true)
      .attr('transform', `translate(0,${height})`)
      .call(xAxis)
      .selectAll('.tick')
      .attr('transform', function(d, i) {
        const { matrix } = this.transform.baseVal.consolidate();
        const xt = matrix.e - (x.bandwidth() / 2) - (i !== 0 ? 2 : 0);
        return `translate(${xt},0)`;
      });

    const yAxisSvg = svg.append('g')
      .classed('axis y-axis', true)
      .call(yAxis);

    svg.selectAll('.tick')
      .attr('font-size', '13')

    svg.append('text')
      .attr('text-anchor', 'middle')
      .attr('class', 'x-label')
      .attr('transform', `translate(${this.width / 2}, ${height + margin.bottom - 10})`)
      .text('Einkommen in Prozent des Medians');

    svg.append('text')
      .attr('text-anchor', 'middle')
      .attr('class', 'y-label')
      .attr('transform', `translate(-${margin.left / 1.5}, ${height / 2})rotate(-90)`)
      .text('Anteil an der Bevölkerung in Prozent');

    this.keys = keys;
    this.bars = bars;
    this.y = y;
    this.x = x;
    this.height = height;
    this.yAxisSvg = yAxisSvg;
    this.yAxis = yAxis;

    this.updateDisplays(this.keys);
    // ReactDOM.render(<ChartHeader margin={margin} x={x}/>, this.refs.chartHeader);
  }

  parseData(data, subdata) {
    const totalData = d3Sum(data, (d) => parseFloat(d[this.year]));

    const parsedData = data.map((d, i) => {
      if(subdata) {
        return {
          key: d.schicht,
          subValue: parseFloat(subdata[i][this.year]) / totalData,
          value: parseFloat((d[this.year] / totalData) - (subdata[i][this.year] / totalData))
        }
      } else {
        return {
          key: d.schicht,
          value: parseFloat(d[this.year]) / totalData,
          subValue: 0
        }
      }
    });

    return parsedData.map(d => {
      let v0 = 0;
      d.values = this.color.domain().map(name => ({name: name, v0: v0, v1: v0 += +d[name]}));
      d.total = d.values[d.values.length - 1].v1;

      return d;
    });
  }

  updateChart() {
    currentMedian = Medians[this.year - 1991];
    const data = this.data;
    //const y = this.y.domain([0, d3Max(data, d => d.total)]);
    const y = this.y;

    this.keys
      .data(data)
      .selectAll('.bar')
      .data((d, i) => {
        d.values = d.values.map(v => {
          v.index = i;
          return v;
        });
        return d.values;
      })
      .transition()
      .attr('y', d => y(d.v1))
      .attr('height', d => y(d.v0) - y(d.v1))
      .on('end', d => this.updateDisplays(this.keys));

    // this.yAxisSvg.transition().call(this.yAxis);
  }

  updateDisplays(keys) {
    let displayValue = 0;
    let subTotal = 0;
    let subMiddle = 0;

    keys.filter((d, i) => i >= 8 && i <= 14).each((d, i) => {
      displayValue += d.total * 100;
      subMiddle += d.subValue * 100;
    });


    keys.each((d, i) => {
      subTotal += d.subValue * 100;
    });

    let subDisplayValue = (subMiddle/subTotal)*100;

    this.props.updateState({
      displayValue,
      subDisplayValue
    });
  }

  shouldComponentUpdate(nextProps) {
    if(nextProps.year !== this.props.year || this.props.subData !== nextProps.subData) {
      this.year = nextProps.year;
      this.data = this.parseData(nextProps.allData, nextProps.subData);
      this.updateChart();
    }
    return false;
  }

  render() {
    return (
      <div className="ifdw-chart">
        <div ref="barchart" className="ifdw-chart--barchart"/>
      </div>
    );
  }

}

export default Barchart;



/** WEBPACK FOOTER **
 ** ./src/components/Barchart/BarChart.js
 **/